import React from 'react';
import { Flame, Clock, Tag, Lock, RotateCcw, Zap } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function OfferSection() {
  const {
    hh,
    mm,
    ss
  } = useCountdown();
  return <section id="oferta" className="py-14 md:py-20 bg-[radial-gradient(ellipse_at_center,#1a0e00_0%,#0a0a0a_70%)]" data-id="element-240">
      <div className="container" data-id="element-241">
        <div className="text-center mb-8 md:mb-10" data-id="element-242">
          <div className="section-label justify-center" data-id="element-243">Tu inversión hoy</div>
          <h2 className="font-playfair text-[clamp(1.7rem,3.5vw,2.7rem)] font-bold leading-[1.2] text-blanco text-center" data-id="element-244">
            Todo lo que recibes por
            <br data-id="element-245" />
            <em className="text-dorado-claro not-italic italic" data-id="element-246">
              un precio excepcional
            </em>
          </h2>
        </div>

        <div className="bg-[linear-gradient(90deg,#1a0800,#0d0600)] border border-[rgba(192,57,43,.3)] rounded-lg p-[18px_24px] flex items-center gap-4 mb-6 flex-wrap max-w-[860px] mx-auto max-sm:flex-col max-sm:items-start max-sm:gap-2.5" data-id="element-247">
          <Flame className="w-[1.3rem] h-[1.3rem] text-rojo-vivo shrink-0" data-id="element-248" />
          <div className="flex-1" data-id="element-249">
            <strong className="block text-blanco text-[.92rem] mb-[3px]" data-id="element-250">
              ¡Alta demanda! Solo quedan plazas disponibles a este precio
            </strong>
            <span className="text-[.78rem] text-gris-texto" data-id="element-251">
              El precio sube automáticamente cuando se agoten los cupos de este
              lanzamiento
            </span>
            <div className="w-full mt-2.5" data-id="element-252">
              <div className="bg-[rgba(255,255,255,.08)] rounded-full h-1.5 overflow-hidden" data-id="element-253">
                <div className="h-full bg-[linear-gradient(90deg,var(--rojo-vivo),var(--dorado))] rounded-full w-[78%]" data-id="element-254" />
              </div>
              <div className="text-[10px] text-rojo-vivo mt-1 font-semibold tracking-[.05em]" data-id="element-255">
                78% de los cupos ya tomados
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-6 items-stretch max-md:grid-cols-1" data-id="element-256">
          <div className="bg-negro-suave border border-[rgba(201,151,43,.2)] rounded-lg p-[30px]" data-id="element-257">
            <img src="https://cdn.magicpatterns.com/uploads/7cUaftCJKVgq8Dz1WsaNYz/Checkout_Pro.png" alt="Código Oscuro — Paquete completo con bonos" className="w-full rounded-md mb-[18px]" data-id="element-258" />
            <h3 className="font-playfair text-[1.15rem] text-dorado-claro mb-[18px] pb-[14px] border-b border-[rgba(201,151,43,.2)]" data-id="element-259">
              Resumen de tu paquete completo
            </h3>
            <div className="flex justify-between items-start py-3 border-b border-[rgba(255,255,255,.05)] text-[.87rem]" data-id="element-260">
              <span className="text-crema-oscuro flex-1" data-id="element-261">
                📘 Ebook Código Oscuro — 12 capítulos
              </span>
              <span className="text-rojo-vivo line-through text-[.82rem] ml-2.5 font-semibold" data-id="element-262">
                $28.99
              </span>
            </div>
            <div className="flex justify-between items-start py-3 border-b border-[rgba(255,255,255,.05)] text-[.87rem]" data-id="element-263">
              <span className="text-crema-oscuro flex-1" data-id="element-264">
                🛡️ Bono #1: Sistema Anti-Manipuladores
              </span>
              <span className="text-rojo-vivo line-through text-[.82rem] ml-2.5 font-semibold" data-id="element-265">
                $8.99
              </span>
            </div>
            <div className="flex justify-between items-start py-3 border-b border-[rgba(255,255,255,.05)] text-[.87rem]" data-id="element-266">
              <span className="text-crema-oscuro flex-1" data-id="element-267">
                🗣️ Bono #2: 7 Frases de Persuasión Rápida
              </span>
              <span className="text-rojo-vivo line-through text-[.82rem] ml-2.5 font-semibold" data-id="element-268">
                $7.99
              </span>
            </div>
            <div className="flex justify-between items-start py-3 text-[.87rem]" data-id="element-269">
              <span className="text-crema-oscuro flex-1" data-id="element-270">
                👥 Bono #3: Comunidad Exclusiva
              </span>
              <span className="text-rojo-vivo line-through text-[.82rem] ml-2.5 font-semibold" data-id="element-271">
                $11.03
              </span>
            </div>
          </div>

          <div className="bg-[linear-gradient(160deg,#0f0a00,#1a0e00_40%,#0a0600)] border-2 border-[rgba(201,151,43,.4)] rounded-xl text-center flex flex-col justify-center relative overflow-hidden shadow-[0_0_60px_rgba(201,151,43,.1),inset_0_1px_0_rgba(201,151,43,.15)]" data-id="element-272">
            {/* Red banner */}
            <div className="bg-[linear-gradient(90deg,#8b1a1a,#c0392b,#8b1a1a)] text-white text-[13px] font-bold tracking-[.15em] uppercase py-3 px-4 text-center w-full flex items-center justify-center gap-2" data-id="element-273">
              <Flame className="w-4 h-4 animate-pulse" data-id="element-274" />
              OFERTA ESPECIAL — SOLO HOY
              <Flame className="w-4 h-4 animate-pulse" data-id="element-275" />
            </div>

            <div className="p-[28px_28px_32px] max-sm:p-[20px_16px_24px] flex flex-col items-center" data-id="element-276">
              {/* Timer */}
              <div className="mb-7" data-id="element-277">
                <div className="text-[10px] uppercase tracking-[.12em] text-rojo-vivo mb-3 font-bold flex items-center justify-center gap-2" data-id="element-278">
                  <Clock className="w-3.5 h-3.5" data-id="element-279" /> Este precio expira en:
                </div>
                <div className="flex gap-2.5 items-center justify-center" data-id="element-280">
                  <div className="flex flex-col items-center" data-id="element-281">
                    <div className="bg-[#0a0a0a] border border-[rgba(201,151,43,.35)] rounded-lg w-[54px] h-[58px] flex items-center justify-center mb-1 shadow-[0_0_15px_rgba(201,151,43,.15),inset_0_2px_10px_rgba(0,0,0,.6)]" data-id="element-282">
                      <span className="font-playfair text-[2rem] font-black text-dorado-claro leading-none" data-id="element-283">
                        {hh}
                      </span>
                    </div>
                    <div className="text-[9px] tracking-[.1em] uppercase text-gris-texto" data-id="element-284">
                      Horas
                    </div>
                  </div>
                  <span className="text-[1.6rem] text-dorado font-black leading-none pb-4 animate-pulse" data-id="element-285">
                    :
                  </span>
                  <div className="flex flex-col items-center" data-id="element-286">
                    <div className="bg-[#0a0a0a] border border-[rgba(201,151,43,.35)] rounded-lg w-[54px] h-[58px] flex items-center justify-center mb-1 shadow-[0_0_15px_rgba(201,151,43,.15),inset_0_2px_10px_rgba(0,0,0,.6)]" data-id="element-287">
                      <span className="font-playfair text-[2rem] font-black text-dorado-claro leading-none" data-id="element-288">
                        {mm}
                      </span>
                    </div>
                    <div className="text-[9px] tracking-[.1em] uppercase text-gris-texto" data-id="element-289">
                      Min
                    </div>
                  </div>
                  <span className="text-[1.6rem] text-dorado font-black leading-none pb-4 animate-pulse" data-id="element-290">
                    :
                  </span>
                  <div className="flex flex-col items-center" data-id="element-291">
                    <div className="bg-[#0a0a0a] border border-[rgba(201,151,43,.35)] rounded-lg w-[54px] h-[58px] flex items-center justify-center mb-1 shadow-[0_0_15px_rgba(201,151,43,.15),inset_0_2px_10px_rgba(0,0,0,.6)]" data-id="element-292">
                      <span className="font-playfair text-[2rem] font-black text-dorado-claro leading-none" data-id="element-293">
                        {ss}
                      </span>
                    </div>
                    <div className="text-[9px] tracking-[.1em] uppercase text-gris-texto" data-id="element-294">
                      Seg
                    </div>
                  </div>
                </div>
              </div>

              {/* Divider */}
              <div className="w-full h-px bg-[linear-gradient(90deg,transparent,rgba(201,151,43,.3),transparent)] mb-6" data-id="element-295" />

              {/* Price block */}
              <div className="text-[.82rem] text-gris-texto uppercase tracking-[.1em] mb-1.5" data-id="element-296">
                Valor total del paquete
              </div>
              <div className="flex items-center justify-center gap-3 mb-2" data-id="element-297">
                <span className="font-playfair text-[1.8rem] text-rojo-vivo line-through opacity-80" data-id="element-298">
                  $27 USD
                </span>
                <span className="bg-rojo-vivo text-white text-[11px] font-bold py-1 px-3 rounded-full tracking-[.06em] animate-pulse" data-id="element-299">
                  76% OFF
                </span>
              </div>

              <div className="text-[.8rem] tracking-[.15em] uppercase text-dorado-claro mb-2 font-semibold" data-id="element-300">
                Hoy solo pagas
              </div>
              <div className="text-[4.5rem] font-black text-[#00E676] leading-none mb-1 max-sm:text-[3.4rem] drop-shadow-[0_0_20px_rgba(0,230,118,.35)]" style={{
              fontFamily: "'Inter', sans-serif"
            }} data-id="element-301">
                <sub className="text-[1.6rem] align-super" data-id="element-302">$</sub>6
                <span className="text-[2.4rem]" data-id="element-303">.36</span>
              </div>
              <div className="text-[.9rem] font-bold text-[#00E676] tracking-[.1em] mb-2 drop-shadow-[0_0_8px_rgba(0,230,118,.25)]" data-id="element-304">
                USD
              </div>

              <div className="text-crema-oscuro font-bold text-[.95rem] mb-2" data-id="element-305">
                ☕ Menos de lo que cuesta un café
              </div>
              <div className="text-gris-texto text-[.78rem] mb-6" data-id="element-306">
                Pago único · Acceso de por vida · Sin suscripción
              </div>

              {/* Urgency */}
              <div className="flex justify-center mb-5" data-id="element-307">
                <span className="text-rojo-vivo text-[12px] font-bold tracking-[.06em] animate-pulse" data-id="element-308">
                  ⏳ El precio sube cuando se agoten los cupos
                </span>
              </div>

              {/* CTA Button */}
              <a href="https://pay.hotmart.com/O105395702C?checkoutMode=10" onClick={trackAddToCart} className="bg-[#00E676] text-[#0a0a0a] text-[15px] font-black py-4 px-10 inline-flex items-center justify-center gap-2.5 rounded-full hover:scale-105 transition-transform duration-200 mb-6 shadow-[0_4px_0_#00c853,0_8px_25px_rgba(0,230,118,.35)] active:shadow-[0_2px_0_#00c853] active:translate-y-[2px] tracking-[.04em]" data-id="element-309">
                <Lock className="w-4.5 h-4.5" data-id="element-310" /> QUIERO ACCEDER AHORA
              </a>

              {/* Trust badges */}
              <div className="flex flex-wrap justify-center gap-4 text-[11px] text-gris-texto mb-5" data-id="element-311">
                <span className="flex items-center gap-1.5" data-id="element-312">
                  <Lock className="w-3 h-3 text-dorado" data-id="element-313" /> Pago seguro
                </span>
                <span className="flex items-center gap-1.5" data-id="element-314">
                  <RotateCcw className="w-3 h-3 text-dorado" data-id="element-315" /> Garantía 7 días
                </span>
                <span className="flex items-center gap-1.5" data-id="element-316">
                  <Zap className="w-3 h-3 text-dorado" data-id="element-317" /> Acceso inmediato
                </span>
              </div>

              {/* Payment methods */}
              <div className="w-full h-px bg-[linear-gradient(90deg,transparent,rgba(255,255,255,.08),transparent)] mb-4" data-id="element-318" />
              <div className="flex items-center justify-center gap-3 flex-wrap text-[11px] font-semibold" data-id="element-319">
                <span className="text-gris-texto" data-id="element-320">Aceptamos:</span>
                <span className="text-[#1a73e8]" data-id="element-321">Visa</span>
                <span className="text-[#eb001b]" data-id="element-322">Mastercard</span>
                <span className="text-[#003087]" data-id="element-323">PayPal</span>
                <span className="text-[#007bc1]" data-id="element-324">Amex</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}